import { BreakingNews } from '@benzinga/basic-news-manager';
import { StockSymbol } from '@benzinga/session';
import { DelayedQuote } from '@benzinga/quotes-manager';
import { HomePageTabKey, PageTabsT } from '../interface';

export type homePageTabs = {
  [key: string]: HomePageTabKey;
};
export const HOME_PAGE_TABS: homePageTabs = {
  MARKETS: 'markets',
  SCREENER: 'screener',
  MY_PORTFOLIO: 'my-portfolio',
  BRIEFS: 'briefs',
  EXCLUSIVES: 'exclusives',
  OFFER: 'offer',
  RECENT: 'recent',
  STOCKIDEAS: 'stockideas',
  TOOLSIDEA: 'toolsidea',
  TRENDING: 'trending',
  WATCH: 'watch',
};

export const pageTabs: PageTabsT = {
  [HOME_PAGE_TABS.TRENDING]: {
    title: 'Trending',
    url: '/',
  },
  [HOME_PAGE_TABS.RECENT]: {
    title: 'Latest News',
    url: '/recent',
  },
  [HOME_PAGE_TABS.MARKETS]: {
    title: 'Markets',
    url: '/markets',
  },
  [HOME_PAGE_TABS.SCREENER]: {
    title: 'Screener',
    url: '/screener',
  },
  [HOME_PAGE_TABS.MY_PORTFOLIO]: {
    title: 'My Portfolio',
    url: '/profile/portfolio',
  },
  // [HOME_PAGE_TABS.STOCKIDEAS]: {
  //   title: 'Stock Ideas',
  //   url: '/stock-ideas',
  // },
  // [HOME_PAGE_TABS.BRIEFS]: {
  //   title: 'Briefs',
  //   url: '/briefs',
  // },
  // [HOME_PAGE_TABS.EXCLUSIVES]: {
  //   title: 'Exclusives',
  //   url: '/exclusives',
  // },
  [HOME_PAGE_TABS.WATCH]: {
    title: 'Benzinga TV',
    url: '/watch',
  },
  // [HOME_PAGE_TABS.TOOLSIDEA]: {
  //   title: 'Premium Tools & Ideas',
  //   shouldReload: true,
  //   clientSide: true,
  //   loaded: false,
  //   url: 'https://www.benzinga.com/premium-products?utm_source=benzigna-homepage&utm_medium=benzinga-homepage'
  // },
};

export interface HeaderProps {
  hideBanner?: boolean;
  hideFooter?: boolean;
  hideNavigationBar?: boolean;
  hideQuoteBar?: boolean;
  hideSearchBar?: boolean;
  isMainDrawerVisible?: boolean;
  breakingNews?: BreakingNews[];
  quotes?: Record<StockSymbol, DelayedQuote> | null;
  navigationLogoVariant?: 'crypto' | 'default';
  marketTicker?: string[];
  showStickyFooter?: boolean;
}
